import { useState } from "react";
import { X } from "lucide-react";

import { MediaUnavailable } from "./media-unavailable";

import { Button } from "@/components/ui/button";
import { OverlayShell } from "@/components/ui/overlay";
import { cn } from "@/lib/utils";

export function ImagePreview({
	src,
	alt,
	className,
}: {
	src: string | null;
	alt: string;
	className?: string;
}) {
	const [openSource, setOpenSource] = useState<string | null>(null);
	const [failedSource, setFailedSource] = useState<string | null>(null);

	if (!src || failedSource === src) {
		return <MediaUnavailable kind="image" className={className} />;
	}

	return (
		<>
			<button
				type="button"
				aria-label={`Ampliar imagem: ${alt}`}
				onClick={() => setOpenSource(src)}
				className={cn(
					"grid h-44 w-64 max-w-full place-items-center overflow-hidden rounded-lg border border-border bg-background focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
					className,
				)}
			>
				<img
					src={src}
					alt={alt}
					loading="lazy"
					onError={() => setFailedSource(src)}
					className="size-full object-contain"
				/>
			</button>
			{openSource === src && (
				<OverlayShell
					label="Imagem ampliada"
					onClose={() => setOpenSource(null)}
					className="items-center justify-center p-4"
				>
					<div className="relative flex max-h-[90dvh] max-w-full flex-col gap-2 rounded-xl bg-card p-3 shadow-overlay">
						<Button
							size="icon"
							variant="ghost"
							aria-label="Fechar imagem"
							className="self-end"
							onClick={() => setOpenSource(null)}
						>
							<X />
						</Button>
						<img
							src={src}
							alt={alt}
							onError={() => setFailedSource(src)}
							className="max-h-[75dvh] max-w-full rounded-lg object-contain"
						/>
					</div>
				</OverlayShell>
			)}
		</>
	);
}
